import { api } from '@/lib/api'
import type {
  Agent,
  AgentPayload,
  AgentsResponse,
  DirectoryResponse,
} from './types'

export type AgentTemplate = {
  id: string
  name: string
  description: string
  allowed_tables: string[]
}

export const agentsApi = {
  list: () => api.get<AgentsResponse>('/api/tenant/agents'),
  create: (body: AgentPayload) =>
    api.post<{ agent: Agent }>('/api/tenant/agents', body),
  update: (id: string, body: AgentPayload) =>
    api.put<{ agent: Agent }>(`/api/tenant/agents/${id}`, body),
  remove: (id: string) => api.del<{ message?: string }>(`/api/tenant/agents/${id}`),
  directoryMembers: () =>
    api.get<DirectoryResponse>('/api/tenant/directory/members'),
  listTemplates: () =>
    api.get<{ templates: AgentTemplate[] }>('/api/tenant/agent-templates'),
  cloneTemplate: (id: string, name?: string) =>
    api.post<{ agent: Agent }>(`/api/tenant/agents/from-template/${id}`, name ? { name } : undefined),
}
